import { useQuery } from "@tanstack/react-query";
import {
  CompanyListItemDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";
import { AxiosResponse } from "axios";

import { DOMAIN_COMPANIES } from "../domain";

import { companiesApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { roleGuard } from "@api";

export const ACTION_GET_COMPANIES = "GET_COMPANIES";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

const getCompanies = async (): Promise<AxiosResponse<CompanyListItemDto[]>> => {
  const response = await companiesApi.companiesControllerGetCompanies();

  return response;
};

export const useGetCompanies = (
  user: UserProfileDto | null,
): {
  companies?: CompanyListItemDto[];
  companiesEnabled: boolean;
  isPendingGetCompanies: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);

  const { data, isPending } = useQuery({
    queryKey: [DOMAIN_COMPANIES, ACTION_GET_COMPANIES],
    queryFn: () => getCompanies(),
    select: (response) => response.data,
    staleTime: TANSTACK_QUERY_STALE_TIME,
    enabled,
  });

  return {
    companies: data,
    companiesEnabled: enabled,
    isPendingGetCompanies: isPending,
  };
};
